'use client';

import { useState } from 'react';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useTranslations } from 'next-intl';
import { MAX_PARAMS_INDEX } from './consts';
import { Button } from '@/components/ui/button';

type Props = {
  allParameters: React.ReactNode[];
};

export const ProductViewParameters: React.FC<Props> = ({ allParameters }) => {
  const [opened, setOpened] = useState(false);
  const t = useTranslations('product');

  const shortParameters = allParameters.slice(0, MAX_PARAMS_INDEX);

  return opened ? (
    <>
      {allParameters}

      <Button
        variant='ghost'
        onClick={() => {
          setOpened(false);
        }}
        className='h-auto p-0 gap-[4px] text-green-day text-[16px] mt-[12px] hover:bg-transparent hover:text-green-day'
      >
        <span>{t('showAll')}</span>
        <IconChevronUp className='justify-self-end text-green-day' size={16} />
      </Button>
    </>
  ) : (
    <>
      {shortParameters}

      {allParameters.length > MAX_PARAMS_INDEX && (
        <Button
          variant='ghost'
          onClick={() => {
            setOpened(true);
          }}
          className='h-auto p-0 gap-[4px] text-green-day text-[16px] mt-[12px] hover:bg-transparent hover:text-green-day'
        >
          <span>{t('showAll')}</span>
          <IconChevronDown className='justify-self-end text-green-day' size={16} />
        </Button>
      )}
    </>
  );
};
